<div class="dialog-agent">
  <h1 mat-dialog-title style="word-break: break-word">{{ data.title | translate }}</h1>
  <div mat-dialog-content style="word-break: break-word">
    {{ data.message | translate }}
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [mat-dialog-close]="true">
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.YES' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.NO' | translate }}</span>
    </button>
  </div>
</div>
